import { createContext } from "react";
import { UndoRedoEntry, UndoRedoV2 } from "./undo-redo-v2";

export type UndoRedoContextType = Pick<
    UndoRedoV2<unknown, unknown, UndoRedoEntry<unknown>>,
    "undo" | "redo" | "canUndo" | "canRedo" | "undoStack$" | "redoStack$" | "clear" | "id"
>;

export const UndoRedoContext = createContext<UndoRedoContextType | undefined>(undefined);
